import { Routes, Route, Navigate } from 'react-router-dom';
import { PickerPage } from './pages/PickerPage.js';
import { PanelView } from './pages/PanelView.js';
import { SourceView } from './pages/SourceView.js';
import { IntercomDeviceView } from './pages/IntercomDeviceView.js';

/**
 * Neutrale Landeseite: Nutzer sollen NICHT in die Panel-Übersicht gelangen.
 * Sie öffnen ausschließlich ihren direkten /panel/:id-Link. Die Übersicht
 * liegt bewusst auf einem eigenen, nicht verlinkten Pfad (/overview), den
 * nur der Admin teilt.
 */
function NoPanel(): JSX.Element {
  return (
    <div className="min-h-full flex flex-col items-center justify-center gap-3 p-6 text-center">
      <span className="font-black italic tracking-tighter leading-none text-2xl select-none">
        <span className="text-white">LIVE</span>
        <span
          className="text-transparent bg-clip-text"
          style={{ backgroundImage: 'linear-gradient(90deg, #ff0099 0%, #00f2ff 100%)' }}
        >
          PULS
        </span>
      </span>
      <p className="text-text-dim text-sm max-w-xs">
        Bitte den vom Administrator geteilten Panel-Link öffnen.
      </p>
    </div>
  );
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<NoPanel />} />
      {/* Übersicht aller Panels – NUR per geteiltem Link, nicht verlinkt. */}
      <Route path="/overview" element={<PickerPage />} />
      <Route path="/panel/:panelId" element={<PanelView />} />
      {/* Audio-Quelle (Web-Einspielung). */}
      <Route path="/source/:panelId" element={<SourceView />} />
      {/* Bidirektionale externe Intercom im Browser (ohne Desktop). */}
      <Route path="/intercom/:deviceId" element={<IntercomDeviceView />} />
      {/* Unbekannte Pfade → neutrale Landeseite, NICHT in die Übersicht. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
